export interface Student {
    id: string;
    firstName: string;
    lastName: string;
    middleName?: string;
    dateOfBirth: string;
    gender: 'male' | 'female';
    grade: number;
    enrollmentDate: string;
    schedule: {
      period: number;
      className: string;
      classroomNumber: string;
      teacherName: string;
    }[];
    address: string;
    city: string;
    state: string;
    zipCode: string;
    primaryPhone: string;
    email: string;
    guardians: any[]; // You might want to define a Guardian interface
    academicPerformance: {
      gpa: number;
      credits: number;
      coursesFailing: number;
    };
    academicAdvisor: string;
    homeroomTeacher: string;
    attendanceRate: number;
    attendanceStatus: 'chronic-absence' | 'active';
    lastAttendanceDate: string;
    daysAbsent: number;
    daysPresent: number;
    tardinessCount: number;
    attendanceRecords: any[]; // You might want to define an AttendanceRecord interface
    interventions: any[]; // You might want to define an Intervention interface
    riskFactors: any[]; // You might want to define a RiskFactor type
    // tasks: {
    //   id: string;
    //   assignedTo: string;
    //   status: 'not_started' | 'in_process' | 'completed';
    //   dueDate: string;
    //   category: string;
    //   // ... other task properties
    // }[];
    photo?: string;
    transportation: 'Other' | 'Bus' | 'Car' |  'Walk';
    fosterCare: boolean;
    homelessStatus: boolean;
    lunchEligibility: boolean;
    secondaryLanguage: string;
    primaryLanguage: string;
    ethnicity: string;
    supportServices: string;
    communityReferrals: string;
    barriers: string;
    supportPlanStatus: 'Not Started' | 'In Progress' | 'Completed';
    extracurricular: string;
    behavioralNotes: string;
    counselingSessions: number;
    behavioralIncidents: number;
    emergencyContactPhone: string;
    emergencyContactName: string;
    immunizationStatus: 'Complete' | 'Incomplete' | 'Exempt';
    medications?: string;
    medicalConditions?: string;
    allergies?: string;
    iepStatus?: 'Yes' | 'No';
    previousPerformance: 'Below Average' | 'Average' | 'Above Average' | 'Excellent';
    secondaryPhone: string;
    preferredName: string;
    interests: string;
    digitalAccess?: 'Yes' | 'No';
    tasks: Task[];
    primaryGuardianName: string;
    primaryGuardianRelationship: string;
    primaryGuardianPhone: string;
    primaryGuardianEmail: string;
  }

export interface Comment {
  id: string;
  userId: string;
  content: string;
  timestamp: string;
}

export interface Attachment {
  id: string;
  name: string;
  url: string;
}

export interface Reminder {

}

export type TaskStatus = 'not_started' | 'in_process' | 'completed' | 'frozen'

export type TaskCategory = 'academic'| 'attendance'| 'behavioral'| 'health' | 'discipline';

export interface Task {
  id: string;
  title: string;
  description: string;
  assignedTo: string;
  dueDate: string;
  status: TaskStatus;  // Using literal types for status
  priority: 'low' | 'medium' | 'high';                  // Using literal types for priority
  category: TaskCategory;
  reminders: string[];
  attachments: Attachment[];
  comments: Comment[];
  createdAt: string;
  updatedAt: string
  interventionId?: string;
}

export enum TaskPriority {
  HIGH = 'high',
  MEDIUM = 'medium',
  LOW = 'low'
}

export interface Guardian {
  id: string;         // Unique identifier for the guardian
  name: string;       // Name of the guardian
  relationship: string; // Relationship to the student
  phone: string;      // Phone number of the guardian
  email: string;      // Email address of the guardian
  isPrimary: boolean; // Indicates if this guardian is the primary guardian
}

export interface Resource {
  id: string;
  name: string;
  category: ResourceCategory;
  description: string;
  contact?: string; // Optional, as it may not always be present
  address?: string; // Optional, as it may not always be present
  website?: string; // Optional, as it may not always be present
  services: string[]; // Array of services offered
}
export enum ResourceCategory {
  ALL = 'all',
  HEALTHCARE = 'Healthcare',
  MENTAL_HEALTH = 'Mental Health',
  ACADEMIC_SUPPORT = 'Academic Support',
  SOCIAL_SERVICES = 'Social Services',
  HOUSING = 'Housing',
  TRANSPORTATION = 'Transportation',
  LEGAL_SERVICES = 'Legal Services',
}

export interface Referral {
  id: string; // Assuming there is an ID for the referral
  studentId: string; // ID of the student being referred
  resourceId: string; // ID of the resource to which the referral is made
  date: string; // Date of the referral
  status: 'pending' | 'completed' | 'canceled'; // Status of the referral
  notes: string; // Additional notes regarding the referral
  followUpDate?: string; // Optional follow-up date
}

export interface RiskFactor {
  type: string; // Type of the risk factor (e.g., attendance, behavior, etc.)
  severity: 'low' | 'medium' | 'high'; // Severity level of the risk factor
  dateIdentified: string; // Date when the risk factor was identified
  notes?: string; // Optional notes regarding the risk factor
}

export interface Intervention {
  id: string;
  type: 'individual' | 'group' | 'family';
  date: string;
  notes: string,
  outcome: string,
  status: "not_started" | "in_process" | "completed" | "frozen";
  tasks: Task[];  
}
